export const formatIndianDate = (dateStr, showTime = false) => {
  if (!dateStr) return "-";

  const date = new Date(dateStr);

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-IN", { month: "short" });
  const year = date.getFullYear();

  if (showTime) {
    const time = date.toLocaleString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${day}-${month}-${year} ${time}`;
  }

  return `${day}-${month}-${year}`;
};